module.exports = __webpack_public_path__ + "img/scene4-5.8e851659.jpg";